import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, space } from '../../theme/tokens';
import { EntityImage } from '../EntityImage';

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 1;
  min-height: 180px;
  overflow: hidden;
  border-radius: ${radius('notice', 'radius-sm')};
  background: ${semantic.bg.surfaceSubtle};
  isolation: isolate;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: ${semantic.bg.overlayImage};
    pointer-events: none;
  }
`;

export const Image = styled(EntityImage)`
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Content = styled.div`
  position: absolute;
  inset: auto 0 0 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
  padding: ${space['space-600']};
  color: ${semantic.text.inverse};
`;

export const Title = styled.h3`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: inherit;
`;

export const Subtitle = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: inherit;
`;

export const Cta = styled.div`
  margin-top: ${space['space-200']};
  align-self: flex-start;
`;

export const Placeholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.tertiary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
`;
